import * as S from './AlphabetButton.styled';

export interface AlphabetButtonProps {
  selectedLetter: string | null;
  onLetterSelect: (letter: string | null) => void;
}

const ALPHABET = [
  'Todas',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
];

export default function AlphabetButton({ selectedLetter, onLetterSelect }: AlphabetButtonProps) {
  const handleLetterClick = (letter: string) => {
    if (letter === 'Todas') {
      onLetterSelect(null);
    } else {
      onLetterSelect(letter === selectedLetter ? null : letter);
    }
  };

  return (
    <S.Container>
      {ALPHABET.map((letter) => (
        <S.Button
          key={letter}
          $isActive={letter === 'Todas' ? selectedLetter === null : letter === selectedLetter}
          onClick={() => handleLetterClick(letter)}
        >
          {letter}
        </S.Button>
      ))}
    </S.Container>
  );
}
